<template>
  <div class="container">
    <div class="row">
      <dashboardHeader>
      </dashboardHeader>
      <div class="row">
        <div v-for="(site, index) in sites" :key="index" class="col-12 my-3">
          <dashboardCard :noFooter="true" :noHeader="true">
            <template slot="body-content">
              <div class="text-left">
                <div class="row">
                  <div class="col-4 d-flex">
                    <img :src="getImage(site)" />
                  </div>
                  <div class="col-8 justify-content-between">
                    <div>
                      <p>
                        <strong>{{ site.name }}</strong>
                      </p>
                      <div class="mb-2" >
                         <a :href="site.domain" target="_blank" >{{ site.domain }}</a>
                      </div>
                      <p>{{ site.description }}</p>
                    </div>
                    <button class="btn btn-franchise" @click.prevent="siteDashboard(site.id)" :disabled="isDisable">
                      <span>Acessar Painel</span>
                    </button>
                  </div>
                </div>
              </div>
            </template>
          </dashboardCard>
        </div>

        <div class="col-12 text-right mt-3 mb-5">
          <button class="btn btn-franchise" @click.prevent="siteCreate()" :disabled="isDisable">
            <span>Contratar novo site</span>
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
name: "Dashboard",
data() {
	return {
	sites: [],
  isDisable:false
	};
},
components: {
	dashboardCard: () => import("@/components/organisms/DashboardCard.vue"),
	dashboardHeader: () => import("@/components/molecules/DashboardHeader.vue"),
},
mounted() {
	if (!localStorage.jwt) {
	this.$router.push("/");
	}
  this.applicationConfig();
	this.sites = this.loadUserSites();
},
methods: {
	async loadUserSites() {
		let result = await this.$run_axios("get", "/user/sites");
		if (result) {
			this.sites = result.data;
		}
	},
	getImage(item) {
		if (item.logo) {
			return item.logo;
		}
    else if(item.avatar){
      return item.avatar;
    }
    else{
      return JSON.parse(localStorage.application).app_logo
    }

	},
	async siteDashboard(idSite){
    this.isDisable = true
		let result = await this.$run_axios("get", `/site/${idSite}/access`);
		if (result.data) {
			window.location.href = result.data.url;
		}
    else{
      this.isDisable = false
    }

		return 1;
	},
  async siteCreate(){
    this.isDisable = true
		let result = await this.$run_axios("get", `/site/create`);

    if (result.siteId) {
      this.siteDashboard(result.siteId);
    } else {
      this.isDisable = false
      alert('Erro ao criar site. Por favor, entre em contato com o atendimento.');
    }

		return 1;
	},
  isSafari() {
    var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return isSafari;
  },
  applicationConfig () {
    if (!localStorage.application) {
      return;
    } 
    let oldLink = document.getElementById("dynamicFavicon");
    const link = document.createElement("link");
    let src;
    
    const app = JSON.parse(localStorage.application);
    document.documentElement.style.setProperty(
      "--main-color",
      app.main_color
    );
    document.head || (document.head = document.getElementsByTagName("head")[0]);
    
    if (this.isSafari()) {
      link.rel = "apple-touch-icon";
      src = app.apple_icon;
    } else {
      link.rel = "icon";
      src = app.favicon;
    }
    
    link.id = "dynamicFavicon";
    link.href = src;

    oldLink && document.head.removeChild(oldLink);
    document.head.appendChild(link);
  }
}
};
</script>

<style>
.card-site{
  min-height: 220px;
  border-radius: 6px;
  box-shadow: 0 6px 16px rgb(0 0 0 / 16%);
  font-size: 14px;
  border: none;
  text-align: left;
  white-space: normal;
}
</style>
